import * as signalR from "@microsoft/signalr";
import { HttpTransportType, HubConnection } from "@microsoft/signalr";
import { useEffect, useRef } from "react";
import { useAuthToken } from "./authHooks";

export const useNotificationsHub = () => {
  const connectionRef = useRef<HubConnection | null>(null);
  const token = useAuthToken();

  useEffect(() => {
    if (!token) return;

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${import.meta.env.VITE_BACKEND_API ?? "https://localhost:44392"}/api/hubs/notifications`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
        accessTokenFactory: () => token,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Error)
      .build();

    connectionRef.current = connection;

    connection.start().catch((err) => console.error(err));

    return () => {
      connection.stop();
    };
  }, [token]);

  return connectionRef.current;
};
